<template>
	<el-card class="account-container">
	    <el-form :model="nameForm" :rules="rules" ref="nameRef" label-width="80px" label-position="right" class="demo-ruleForm">
	      <el-form-item label="登录名：" prop="username">
	        <el-input style="width: 200px" v-model="nameForm.username" :disabled="true"></el-input>
	      </el-form-item>
	      <el-form-item label="昵称：" prop="nick_name">
	        <el-input style="width: 200px" v-model="nameForm.nick_name"></el-input>
	      </el-form-item>
	      <el-form-item>
	        <el-button type="danger" @click="submitName">确认修改</el-button>
	      </el-form-item>
	    </el-form>
	  </el-card>
	  
	  <el-card class="account-container">
    <el-form :model="passForm" :rules="rules" ref="passRef" label-width="80px" label-position="right" class="demo-ruleForm">
      <el-form-item label="原密码：" prop="oldpass">
        <el-input style="width: 200px" v-model="passForm.oldpass" show-password></el-input>
      </el-form-item>
      <el-form-item label="新密码：" prop="newpass">
        <el-input style="width: 200px" v-model="passForm.newpass" show-password></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="danger" @click="submitPass">确认修改</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
	export default {
		data(){
			return{
				id:'',
				nameForm:{
					username:'',
					nick_name:'',
				},
				passForm:{
					oldpass:'',
					newpass:'',
				},
				rules:{
					username:[{
						required: true,
						message: '用户名不能为空',
						trigger: 'change'
					}],
					nick_name:[{
						required: true,
						message: '昵称不能为空',
						trigger: 'change'
					}],
					oldpass:[{
						required: true,
						message: '原密码不能为空',
						trigger: 'change'
					}],
					newpass:[{
						required: true,
						message: '新密码不能为空',
						trigger: 'change'
					}],
				}
		
			}
		},
		mounted(){
				this.httpPost({
					url:'/admin/home/home',
				}).then((res)=>{
					this.nameForm.username = res.data.username;
					this.nameForm.nick_name = res.data.nick_name;
					this.id = res.data.id;
				})
				
		},
		methods:{
			submitName(){
				this.$refs['nameRef'].validate((valid)=>{
						if(valid){
							this.updateName();
						}else{
							console.log('error submit!')
							return false;
						}
					})
			},
			updateName(){
				this.httpPost({
					url:'/admin/admin/changeName',
					data:{nick_name:this.nameForm.nick_name,id:this.id}
				}).then((res)=>{
					if(res.code ==1){
						this.$message.success(res.msg);
					}
				}).catch((res)=>{
					this.$message.error(res.msg);
				})
			},
			submitPass(){
				this.$refs['passRef'].validate((valid)=>{
						if(valid){
							this.updatePass();
						}else{
							console.log('error submit!')
							return false;
						}
					})
			},
			updatePass(){
				this.httpPost({
					url:'/admin/admin/changePassword',
					data:{oldpass:this.passForm.oldpass,newpass:this.passForm.newpass,id:this.id}
				}).then((res)=>{
					this.$message.success(res.msg);
				})
			}
		},
		created(){
			
		}
	}
</script>

<style>
	.account-container {
	    margin-bottom: 20px;
	  }
</style>
